<template>
  <div class="card-simple-actu">
    <card :theme="'blue'" :shadow="true" class="u-align--left u-bg--white">
      <a class="card-container" :href="'/actualite/' + actu.node.slug">
        <tag :tag="'Actualités de l’app'" class="u-color--blue u-bg--blue-soft"/>
        <simple-title :text="actu.node.title" />
        <sub-title :text="actu.node.subtitle"/>
        <paragraph :text="actu.node.chapo" />
        <block-infos :infos="[{label: 'Posté le', data: actu.node.publicationDate, date:true}, {label: 'par', data: actu.node.updatedBy}, {label: 'Pathologie', data: actu.node.pathology ? actu.node.pathology.name : ''}]"/>
        <link-arrow-left :theme="'blue'" :text="'Voir le détail de l\'actualité'" class="u-color--blue" :href="'/actualite/' + actu.node.slug" />
      </a>
      <div class="col-12 d-flex justify-content-center button" v-if="flatButton">
        <flat-button :text="'Voir toutes les actualités'" class="u-bg--blue" :href="'/actualites'"/>
      </div>
    </card>
  </div>
</template>

<script>
import Card from './../Granular/Card'
import Tag from "../Granular/Tag";
import SimpleTitle from "../../Core/SimpleTitle";
import Paragraph from "../../Core/Paragraph";
import BlockInfos from "../Granular/BlockInfos";
import FlatButton from './../../Core/FlatButton'
import LinkArrowLeft from "../../Core/Link/LinkArrowLeft";
import SubTitle from "../../Core/SubTitle";

export default {
  name: 'card-simple-actu',
  props: ['actu', 'flatButton'],
  components: {
    SubTitle,
    LinkArrowLeft,
    BlockInfos,
    Paragraph,
    SimpleTitle,
    Tag,
    Card,
    FlatButton,
  }
}
</script>

<style lang="scss">
.card-simple-actu {

  .card-container {
    padding: rem(30px) rem(30px) 0;
    width: 100%;

    @include mq($until: MD) {
      padding: rem(20px) rem(15px) 0;
    }
  }

  .button {
    padding: 0;
    min-height: rem(50px);


    .cta-flat:hover, &:focus {
      background-color:#FF505B;
    }
  }
}

    .cta-flat.u-bg--blue {

    	background-color:#ff5e5b;

    	&:hover,
    	&:focus{background-color:#FF505B!important}

    }

</style>
